module.exports = __webpack_public_path__ + "img/nfi_slide_2.bdbcd40a.jpg";